import { AnrokDefaultTaxMethodSchema } from '@vy/integrations-types';
import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const AnrokConfigurationFormSchema = oz.object({
  apiKey: oz.string(),
  defaultExternalProductId: oz.string(),
  defaultTaxMethod: AnrokDefaultTaxMethodSchema,
});

export type AnrokConfigurationFormValues = oz.infer<typeof AnrokConfigurationFormSchema>;
export type AnrokConfigurationControl = Control<AnrokConfigurationFormValues>;
